import { createFileRoute } from '@tanstack/react-router'
import { ProfileScreen } from '@web/app/features/profile'
import { User } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/cuenta/perfil')({
  component: ProfileScreen,
  staticData: {
    metaRoute: {
      title: 'Perfil',
      order: 1,
      icon: User,
    },
  },
})
